// src/components/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#f0f0f0',
      padding: '20px',
      marginTop: '50px',
      textAlign: 'center',
      fontSize: '14px'
    }}>
      <p>© 2025 Vanigam360. All rights reserved.</p>
      <div style={{ marginTop: '10px' }}>
        <Link to="/contact" style={{ margin: '0 10px' }}>Contact</Link>
        <Link to="/shipping-policy" style={{ margin: '0 10px' }}>Shipping Policy</Link>
        <Link to="/terms-and-conditions" style={{ margin: '0 10px' }}>Terms & Conditions</Link>
        <Link to="/refund-policy" style={{ margin: '0 10px' }}>Cancellation & Refund</Link>
        <Link to="/privacy-policy" style={{ margin: '0 10px' }}>Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default Footer;
